define('shoptheme/components/layout/page/sidebar-related',[
	"jquery",
	"lodash",
	"cartware/components/_base"
], function(
	$,
	_,
	Component
) {
	return Component.create({

		$init: function() {
			var self = this;

			this.container = $('.b_main-container__col2-right-col-right--sidebar');
			this.headlines = this.container.find('.b_main-container__sidebar-headline--container');

			this.headlines.on('click', function() {
				self.container.toggleClass('active');
			});
		}
	});

});
